<template>
  <vue-form :state="formState" class="step-three" id="step-three">
    <h2 class="fs-24 font-smoothing">Kontaktoplysninger</h2>
    <step>
      <p class="fs-14 color-grey-3 input-title font-smoothing mb-2">Indtast dit telefonnummer <span class="asterisk">*</span></p>
      <div class="d-flex">
        <validate>
          <input required class="input-default phone-prefix" type="text" autocomplete="nope" v-model.trim="phonePrefix" name="phonePrefix" :class="{'error-border' : show_errors.phonePrefix}" >
        </validate>
        <validate>
          <input required class="input-default phone-number" type="text" v-model.trim="phoneNumber" name="phoneNumber" placeholder="00 00 00 00" :class="{'error-border' : show_errors.phoneNumber}">
        </validate>
      </div>

      <p class="fs-14 color-grey-3 input-title font-smoothing mb-2">Indtast dit fulde navn <span class="asterisk">*</span></p>
      <div class="d-block d-lg-flex">
        <validate class="w-100 w-lg-50">
          <input required class="input-default first-name" type="text" v-model.trim="firstName" name="firstName" placeholder="Fornavn(e)" :class="{'error-border' : show_errors.firstName}">
        </validate>
        <validate class="w-100 w-lg-50">
          <input required class="input-default last-name mt-2 mt-lg-0" type="text" v-model.trim="lastName" name="lastName" placeholder="Efternavn" :class="{'error-border' : show_errors.lastName}">
        </validate>
      </div>

      <p class="fs-14 color-grey-3 input-title font-smoothing mb-2">Indtast din email adresse <span class="asterisk">*</span></p>
      <validate tag="div" class="d-flex">
        <input email-custom-validator required class="input-default w-100" type="email" v-model.trim="email" name="email" placeholder="Email adresse" :class="{'error-border' : show_errors.email}">
      </validate>

      <p class="fs-14 color-grey-3 input-title font-smoothing mb-2">Indtast opsamlingsadressen: <span class="asterisk">*</span></p>
      <div class="d-block d-lg-flex">
        <validate class="w-100 w-lg-50">
          <input required class="input-default address-road w-100" type="text" v-model.trim="addressRoad" name="addressRoad" placeholder="Vejnavn" :class="{'error-border' : show_errors.addressRoad}">
        </validate>
        <validate class="w-100 w-lg-50 mt-2 mt-lg-0">
          <input required class="input-default address-number" type="text" v-model.trim="addressNumber" name="addressNumber" placeholder="Husnummer, etage, dør" :class="{'error-border' : show_errors.addressNumber}">
        </validate>
      </div>
      <div class="d-block d-lg-flex mt-3">
        <validate>
          <input required @keyup='validatePostnummer(addressZip)' class="input-default address-zip" type="text" v-model.trim="addressZip" name="addressZip" placeholder="Postnummer" :class="{'error-border' : show_errors.addressZip}">
          <small class="d-none">Fejl i postnummer</small>
        </validate>
        <validate class="w-100 mt-2 mt-lg-0">
          <input required class="input-default address-city" type="text" v-model.trim="addressCity" name="addressCity" placeholder="By" :class="{'error-border' : show_errors.addressCity}">
        </validate>
      </div>
    </step>
  </vue-form>
</template>

<script>
import Step from '@/components/Step'
// import BooleanSlider from '@/components/BooleanSlider'
import { mapFields } from 'vuex-map-fields'
import { mapMutations } from 'vuex'
import { page } from 'vue-analytics'

export default {
  name: 'StepThree',
  components: {
    Step,
    // BooleanSlider
  },
  computed: {
    ...mapFields({
      phonePrefix: 'contact.phone.prefix',
      phoneNumber: 'contact.phone.number',
      firstName: 'contact.firstName',
      lastName: 'contact.lastName',
      email: 'contact.email',
      addressRoad: 'contact.address.road',
      addressNumber: 'contact.address.number',
      addressZip: 'contact.address.zip',
      addressCity: 'contact.address.city',
      shouldDisplayErrors: 'shouldDisplayErrors'
    }),
    invalid() {
      return this.formState.$invalid;
    }
  },
  data() {
    return {
      isAddress: true,
      formState: {},
      show_errors: {
        phoneNumber: false,
        firstName: false,
        lastName: false,
        email: false,
        addressRoad: false,
        addressNumber: false,
        addressZip: false,
        addressCity: false,
      }
    }
  },
  watch: {
    invalid(invalid, prevInvalid) {
      if (invalid && !prevInvalid) {
        this.$emit('invalid');
        this.validatePostnummer(this.addressZip);
      }

      if (!invalid) {
        this.$emit('valid');
        this.validatePostnummer(this.addressZip);
      }
    },
    shouldDisplayErrors(){
      this.setErrors();
    },
    formState: {
      deep: true,
      handler() {
        if (this.shouldDisplayErrors) {
          this.setErrors();
        }
      },
    },
  },
  beforeDestroy() {
    this.addressRoad = (this.addressRoad).trim();
  },
  mounted() {
    page('/stepThree');
  },
  methods: {
    ...mapMutations(['validateTravelTotal']),

    validate(address) {
      this.validateTravelTotal(address);
    },
    setErrors() {
      let errors = this.formState.$error;
      for (let key in errors) {
        if (errors.hasOwnProperty(key)) {
          this.show_errors[key] = errors[key].$invalid;
        }
      }
    },
    validatePostnummer(postnummer) {
      if (/\D/.test(postnummer) || postnummer.length !== 4 || parseInt(postnummer)>=5000 || postnummer.substr(0,2)=="37" ||  postnummer.substr(0,2)=="39" ) {
        document.querySelector('input[name=addressZip]').style.border = '1px solid red';
        document.querySelector('small').style.display = 'block';

        const el = document.querySelector('small');
        if (el.classList.contains('d-none')) {
          el.classList.remove('d-none');
        }

        this.$emit('invalid');
      } else {
        document.querySelector('input[name=addressZip]').style.border = '1px solid #E2E2E2';
        document.querySelector('small').style.display = 'none';

        if (!this.formState.$invalid) {
          this.$emit('valid');
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @use "../assets/scss/variables" as *;
  @use "../assets/scss/media-queries" as *;

  .step-three {
    padding: 60px 0 0;

    input {
      width: 100%;
    }

    .step {
      border-bottom: 0;
      padding: 60px 80px 140px;
      position: relative;

      @include max-screen(991px) {
        padding: 30px 30px 140px;
      }

      .back-btn {
        left: 0;
        bottom: 0;
      }
    }

    h2 {
      padding-left: 80px;
      margin-bottom: 60px;
    }

    .input-title {
      margin-top: 30px;
    }

    .phone-number,
    .last-name,
    .address-number,
    .address-city,
    .alt-address-number,
    .alt-address-city {
      margin-left: -1px;
    }

    .address-zip,
    .alt-address-zip {
      @include max-screen(991px) {
        width: 100%;
      }
    }

    .address-road,
    .alt-address-road {
      width: 200px;

      @include max-screen(991px) {
        width: 100%;
      }
    }

    .phone-prefix {
      width: 80px;
    }

    .phone-number {
      width: 260px;

      @include max-screen(991px) {
        width: 100%;
      }
    }

    small {
      display: block;
      margin-top: 0.4em;
      color: #ff0000;
    }
  }
</style>
